import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
  id?: number;
  email: string;
  phone?: string;
  roles: string[];
}

interface AuthState {
  user: User | null;
  token: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  token: localStorage.getItem("token"),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    stopLoading(state) {
      state.loading = false;
    },
    loginSuccess(state, action: PayloadAction<string>) {
      state.loading = false;
      state.token = action.payload;
      localStorage.setItem("token", action.payload);
    },
    registerSuccess(state, action: PayloadAction<User>) {
      state.loading = false;
      state.user = action.payload;
    },
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    authFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
  },
});

export const {
  startLoading,
  stopLoading,
  loginSuccess,
  registerSuccess,
  setUser,
  authFailure,
  logout,
} = authSlice.actions;

export default authSlice;
